export default __webpack_public_path__ + "static/media/iconCard1.32d32afd.svg";